import { render } from "./ChartInputs.vue?vue&type=template&id=366c1e0a"
import script from "./ChartInputs.vue?vue&type=script&lang=js"
export * from "./ChartInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__